import type { ActiveCase, RunState } from "../types/index.js";

export function canSpendEnergy(run: RunState, _activeCase: ActiveCase): boolean {
  return run.energy >= 1;
}

export function spendEnergy(
  run: RunState,
  activeCase: ActiveCase,
): { run: RunState; activeCase: ActiveCase } | null {
  if (run.energy < 1) return null;
  return {
    run: { ...run, energy: run.energy - 1 },
    activeCase,
  };
}
